'use strict'
import helper from '../services/helper'
export default {
  getNews (cb, errorCb, request = '') {
    let page   = request.page
    let params = helper.getFilterURL(request.params)
    if (typeof page !== 'number') {
      page = 1;
    }
    axios.get(`/news?page=${page}${params}`)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/admin/api/news.js